import { IBreakVM } from "../../models/response/IReservationResponse";

// Initial State set for Headquarter Add Form
export const AddBreakState: IBreakVM = {
  Id: -1,
  Title: "",
  Date : "",
  StartTime: "",
  EndTime: "",
  StaffId: -1,
  StoreId: -1,
  TotalTime: 0,
  Remarks: "",
  BreakType: 0
};
